import { createStore, applyMiddleware } from "redux";

import rootReducer from "./reducers";

import permissionMiddleware from "./middlewares/permissions";

const Store = createStore(rootReducer, applyMiddleware(permissionMiddleware));

export default Store;



// WEBPACK FOOTER //
// ./src/store/index.js